import PropTypes from "prop-types";

export const projectShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  isCompleted: PropTypes.bool,
});

export const projectsShape = PropTypes.arrayOf(projectShape);

export const taskShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  isCompleted: PropTypes.bool,
});

export const tasksShape = PropTypes.arrayOf(taskShape);

export const timeRecordShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  value: PropTypes.number.isRequired,
  recordDate: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  jobTypeId: PropTypes.number,
  summary: PropTypes.string,
  billableStatus: PropTypes.number,
  createdOn: PropTypes.number,
});

export const userShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string.isRequired,
  dailyCapacity: PropTypes.arrayOf(PropTypes.number).isRequired,
  role: PropTypes.string,
});

export const availabilityRecordShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  user_id: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  start_date: PropTypes.number.isRequired,
  end_date: PropTypes.number.isRequired,
});
